/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';

import { AdDashboardDropdownExItem } from '../models/ad-dashboard-dropdown-ex-item';
import { AdDashboardQueryExReq } from '../models/ad-dashboard-query-ex-req';
import { AdDashboardResultExRes } from '../models/ad-dashboard-result-ex-res';
import { MasterCategoryAndSeverityResItem } from '../models/master-category-and-severity-res-item';

@Injectable({ providedIn: 'root' })
export class AuditDashboardService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `apiAuditDashboardQueryPost()` */
  static readonly ApiAuditDashboardQueryPostPath = '/api/audit/dashboard/query';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiAuditDashboardQueryPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiAuditDashboardQueryPost$Response(
    params?: {
      body?: AdDashboardQueryExReq
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<AdDashboardResultExRes>> {
    const rb = new RequestBuilder(this.rootUrl, AuditDashboardService.ApiAuditDashboardQueryPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<AdDashboardResultExRes>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiAuditDashboardQueryPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiAuditDashboardQueryPost(
    params?: {
      body?: AdDashboardQueryExReq
    },
    context?: HttpContext
  ): Observable<AdDashboardResultExRes> {
    return this.apiAuditDashboardQueryPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<AdDashboardResultExRes>): AdDashboardResultExRes => r.body)
    );
  }

  /** Path part for operation `apiAuditDashboardMasterCategorySeverityContainPost()` */
  static readonly ApiAuditDashboardMasterCategorySeverityContainPostPath = '/api/audit/dashboard/master-category-severity-contain';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiAuditDashboardMasterCategorySeverityContainPost()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiAuditDashboardMasterCategorySeverityContainPost$Response(
    params?: {
      containText?: string;
      max?: number;
      workGroupList?: Array<number>;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<MasterCategoryAndSeverityResItem>>> {
    const rb = new RequestBuilder(this.rootUrl, AuditDashboardService.ApiAuditDashboardMasterCategorySeverityContainPostPath, 'post');
    if (params) {
      rb.query('containText', params.containText, {});
      rb.query('max', params.max, {});
      rb.query('workGroupList', params.workGroupList, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<MasterCategoryAndSeverityResItem>>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiAuditDashboardMasterCategorySeverityContainPost$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiAuditDashboardMasterCategorySeverityContainPost(
    params?: {
      containText?: string;
      max?: number;
      workGroupList?: Array<number>;
    },
    context?: HttpContext
  ): Observable<Array<MasterCategoryAndSeverityResItem>> {
    return this.apiAuditDashboardMasterCategorySeverityContainPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<MasterCategoryAndSeverityResItem>>): Array<MasterCategoryAndSeverityResItem> => r.body)
    );
  }

  /** Path part for operation `apiAuditDashboardDdlListGet()` */
  static readonly ApiAuditDashboardDdlListGetPath = '/api/audit/dashboard/ddl-list';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiAuditDashboardDdlListGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiAuditDashboardDdlListGet$Response(
    params?: {
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<AdDashboardDropdownExItem>> {
    const rb = new RequestBuilder(this.rootUrl, AuditDashboardService.ApiAuditDashboardDdlListGetPath, 'get');
    if (params) {
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<AdDashboardDropdownExItem>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiAuditDashboardDdlListGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiAuditDashboardDdlListGet(
    params?: {
    },
    context?: HttpContext
  ): Observable<AdDashboardDropdownExItem> {
    return this.apiAuditDashboardDdlListGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<AdDashboardDropdownExItem>): AdDashboardDropdownExItem => r.body)
    );
  }

}
